<template>
  <div class="highlighted u-pad-y-xl u-pad-y-md--sm">
    <div :class="data.titleRight ? 'u-w5of12 u-marg-l-7of12' : 'u-w10of12 u-marg-l-1of12'">
      <h3 class="u-blue t-text t-bold">{{data.subTitle}}</h3>
    </div>
    <div class="u-row u-row--sm u-marg-t-md">
      <div v-if="!data.titleRight" class="u-w4of12 u-marg-l-1of12 u-pad-x-sm u-w10of12--sm u-marg-b-md--sm">
        <p class="t-h3">{{data.titre}}</p>
      </div>
      <div class="u-w5of12 u-marg-x-1of12 u-pad-x-sm u-w10of12--sm">
        <p class="t-text u-white-space" v-if="data.description">{{data.description}}</p>
        <p class="t-h4 u-marg-t-md" v-if="data.deliverablesTitle">{{data.deliverablesTitle}}</p>
        <p class="t-text u-marg-t-xs" v-if="data.deliverablesContent">{{data.deliverablesContent}}</p>
      </div>
      <div v-if="data.titleRight" class="u-w4of12 u-pad-x-sm u-w10of12--sm u-marg-t-md--sm">
        <p class="t-h3">{{data.titre}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>